import { useEffect, useRef, useState } from "react";

export const useImageCrop = () => {
  // UI-driving state
  const [logoModal, setLogoModal] = useState(false);
  const [upImg, setUpImg] = useState("");
  const [imgRef, setImgRef] = useState(null);
  const [crop, setCrop] = useState({ aspect: 1, unit: "%", width: 200 });

  // Non-UI refs to avoid re-renders
  const base64ImgRef = useRef("");
  const previewUrlRef = useRef(null);
  const imageTypeRef = useRef("image/jpeg");

  const onLoad = (img) => {
    setImgRef(img);
  };

  const makeClientCrop = async (cropData) => {
    if (imgRef && cropData?.width && cropData?.height) {
      await createCropPreview(imgRef, cropData, "newFile.jpeg");
    }
  };

  useEffect(() => {
    if (imgRef) {
      makeClientCrop(crop);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imgRef]);

  const createCropPreview = async (image, cropData, fileName) => {
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = Math.ceil(cropData.width * scaleX);
    canvas.height = Math.ceil(cropData.height * scaleY);
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      image,
      Math.ceil(cropData.x * scaleX),
      Math.ceil(cropData.y * scaleY),
      Math.ceil(cropData.width * scaleX),
      Math.ceil(cropData.height * scaleY),
      0,
      0,
      Math.ceil(cropData.width * scaleX),
      Math.ceil(cropData.height * scaleY)
    );

    return new Promise((_resolve, reject) => {
      canvas.toBlob(
        (blob) => {
          if (!blob) {
            reject(new Error("Canvas is empty"));
            return;
          }
          blob.name = fileName;
          if (previewUrlRef.current) {
            window.URL.revokeObjectURL(previewUrlRef.current);
          }
          previewUrlRef.current = window.URL.createObjectURL(blob);
          getBase64(blob).then((val) => {
            base64ImgRef.current = val;
          });
        },
        "image/jpeg",
        1
      );
    });
  };

  const getBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

  const getCroppedFile = async () => {
    if (!base64ImgRef.current) return null;
    const response = await fetch(base64ImgRef.current);
    const blob = await response.blob();
    return new File([blob], "cropped-image.jpeg", { type: "image/jpeg" });
  };

  const setImageType = (type) => {
    imageTypeRef.current = type || "image/jpeg";
  };

  return {
    // UI state
    logoModal,
    setLogoModal,
    upImg,
    setUpImg,
    imgRef,
    setImgRef,
    crop,
    setCrop,
    // Refs
    base64ImgRef,
    previewUrlRef,
    imageTypeRef,
    // handlers
    onLoad,
    makeClientCrop,
    getCroppedFile,
    setImageType,
  };
}; 